import useTicketStatsQuery from '~/hooks/services/servicenow/queries/useTicketStatsQuery'

import moment from 'moment'
import { FaCloud } from 'react-icons/fa'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

const thirtyDaysAgo = moment().subtract(30, 'days').startOf('day')
const today = moment().endOf('day')

const RecentAzureDeploymentsTile = () => {
  const navigate = useNavigate()

  const { data: ticketStats, isLoading } = useTicketStatsQuery({
    dateRange: [thirtyDaysAgo, today],
    requester_page: 'azure_deployment_history'
  })

  const totalTickets = ticketStats?.open ?? 0

  const handleNavigate = () => {
    const startDateFormatted = thirtyDaysAgo.format('YYYY-MM-DD')
    const endDateFormatted = today.format('YYYY-MM-DD')
    navigate(`/azure_deployments/history?dateRange=${startDateFormatted},${endDateFormatted}`)
  }

  return (
    <Tile onMouseDown={handleNavigate}>
      <TileHeader loading={isLoading}>
        <TileHeader.Title>{totalTickets ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Recent Azure Deployments</TileHeader.Subtitle>
        <TileHeader.Item>
          <FaCloud className="h-10 w-10 text-th-info" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default RecentAzureDeploymentsTile
